// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2oMWx","name":"styles_name__39Cmx","phone":"styles_phone__2AjpN"};